export const SITE = {
  brand: "TWGAS",
  fullName: "TWGAS Athletics & Development",
  meaning: "The Work Gone Always Show",
  slogan: ["Prepare.", "Perform.", "Position.", "Profit."],
  instagramHandle: "@twgas_",
  instagramUrl: "https://instagram.com/twgas_",
  ownerEmail: "twgas402@hotmail.com",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_4a941eff-9911-441a-8b24-30a7d5ff27fb/artifacts/9f22m24m_BBDC24AA-6BB2-49BA-9965-23E7CF5E1B4D.PNG",
  heroVideo:
    "https://customer-assets-jt897jd0.emergentagent.net/job_4a941eff-9911-441a-8b24-30a7d5ff27fb/artifacts/5j8c5hzw_twgas.mp4",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Program", to: "/program" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PILLARS = [
  {
    num: "01",
    key: "nil",
    title: "NIL Development",
    tag: "Profit",
    lead: "Turn your name, image, and likeness into a business.",
    bullets: [
      "NIL education & compliance guidance",
      "Personal brand architecture",
      "Sponsorship & partnership sourcing",
      "Content strategy for social + press",
    ],
    image:
      "https://images.unsplash.com/photo-1763280290224-1b7ed510a31e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHx2aWRlb2dyYXBoZXIlMjBmaWxtaW5nJTIwc3BvcnRzJTIwY2FtZXJhfGVufDB8fHx8MTc4MjY5OTE5OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "02",
    key: "mentoring",
    title: "Mentoring",
    tag: "Prepare",
    lead: "Guidance from people who have been through it.",
    bullets: [
      "One-on-one mentoring cadence",
      "Life skills & character work",
      "Accountability + mindset systems",
      "Guidance from lived-in athletes",
    ],
    image:
      "https://images.unsplash.com/photo-1672344048213-76b6e77304bd",
  },
  {
    num: "03",
    key: "skill",
    title: "Skill Development",
    tag: "Perform",
    lead: "Train like the version of you the game is waiting for.",
    bullets: [
      "Position-specific training",
      "Strength & conditioning support",
      "Performance tracking & feedback",
      "Access to trainers + resources",
    ],
    image:
      "https://images.pexels.com/photos/34509011/pexels-photo-34509011.jpeg",
  },
  {
    num: "04",
    key: "iq",
    title: "IQ Enrichment",
    tag: "Position",
    lead: "Sharpen the mind that controls the body.",
    bullets: [
      "Film study & the mental game",
      "Decision-making & leadership",
      "Academic support & tutoring",
      "Financial literacy & life planning",
    ],
    image:
      "https://images.unsplash.com/photo-1672344048213-76b6e77304bd",
  },
];

export const OFFERINGS = [
  "Social Media Branding",
  "Videography",
  "Photography",
  "Interviews",
  "A Day In A Life",
];
